import React, { ReactElement, ReactNode, FC } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

const styles = {
  '&.MuiTooltip-tooltip': {
    backgroundColor: '#23252F',
    borderRadius: '12px',
    padding: '4px 8px',
    fontFamily: 'Inter',
    fontSize: '10px',
    textTransform: 'capitalize',
    maxWidth: 'unset',
    '&.MuiTooltip-tooltipPlacementTop': {
      marginBottom: '4px',
    },
  },
};

const lightStyles = {
  '&.MuiTooltip-tooltip': {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '4px 8px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400',
    textTransform: 'capitalize',
    color: '#23252F',
    border: '1px solid #EDEFF7',
    boxShadow: '1px 2px 2px 0px rgba(35, 37, 47, 0.04), 0px 4px 10px 0px rgba(35, 37, 47, 0.10)',

    '& span': { fontWeight: '600' },

    '&.MuiTooltip-tooltipPlacementTop': {
      marginBottom: '4px',
    },
  },
};

type Props = {
  title: string | JSX.Element | React.ReactNode;
  children: ReactElement<any, any>;
  lightMode?: boolean;
  additionalClassName?: string;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
};

const CustomTooltip: FC<Props> = ({
  title,
  children,
  placement,
  lightMode,
  additionalClassName,
}) => {
  return (
    <Tooltip
      placement={placement}
      title={title}
      componentsProps={{ tooltip: { sx: lightMode ? lightStyles : styles } }}
      className={!!additionalClassName ? additionalClassName : ''}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
